module.exports = __webpack_public_path__ + "static/hvik_pabbi_1-debe95d8884ef15d13d3f4916e3d88d3.jpg";